import Module from './Module'

export type GridElement = {
  row: number;
  col: number;
  xPos: number;
  yPos: number;
}

export type GridElementState = {
  rect: d3.Selection<SVGRectElement, unknown, null, undefined>;
  module: Module | null;
}


export default class ConfiguratorGridUtils {
  public static async svgToPng(svgString: string, width: number, height: number) {
    const imgsrc = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svgString)))}`

    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    canvas.width = width
    canvas.height = height

    const image = new Image()
    image.src = imgsrc
    return new Promise<string>((resolve, reject) => {
      image.onload = () => {
        if (context) {
          context.drawImage(image, 0, 0, width, height)
          resolve(canvas.toDataURL())
        }
      }
    })
  }

  public static gridDataGenerator(boxSize: number, gridSize: number) {
    const grid: GridElement[] = []
    let xPos = 0
    let yPos = 0

    for (let row = 0; row < gridSize; row++) {
      for (let col = 0; col < gridSize; col++) {
        grid.push({
          row,
          col,
          xPos,
          yPos,
        })
        xPos += boxSize
      }
      xPos = 0
      yPos += boxSize
    }
    return grid
  }

  public static getTranslation (gridSize: number, boxSize: number, scaleBy: number, svgHeight: number, svgWidth: number, minRow: number, minCol: number) {
    const maxSize = gridSize * boxSize
    const maxHeight = maxSize * scaleBy - svgHeight
    const maxWidth = maxSize * scaleBy - svgWidth
    const scaledTopPos = minRow * boxSize * scaleBy
    const scaledLeftPos = minCol * boxSize * scaleBy
    const topPos = this.getIntervalLimit(scaledTopPos, 0, maxHeight)
    const leftPos = this.getIntervalLimit(scaledLeftPos, 0, maxWidth)
    return { leftPos, topPos }
  }

  public static getIntervalLimit(x: number, minLimit: number, maxLimit: number) {
    if (x >= minLimit && x <= maxLimit) {
      return x
    }
    const closestLimit = x < minLimit ? minLimit : maxLimit
    return closestLimit
  }

  public static getEnclosingSquare (gridState: GridElementState[][]) {
    let minRow = Infinity
    let maxRow = -Infinity
    let minCol = Infinity
    let maxCol = -Infinity

    for (let i = 0; i < gridState.length; i++) {
      for (let j = 0; j < gridState[i].length; j++) {
        if (gridState[i][j].module) {
          if (minRow > i) minRow = i
          if (maxRow < i) maxRow = i

          if (minCol > j) minCol = j
          if (maxCol < j) maxCol = j

        }
      }
    }
    return {
      minRow, maxRow, minCol, maxCol,
    }
  }

  public static indexIsValid (index: number) {
    return index !== Infinity && index !== -Infinity
  }
}
